/* Photo HD: every product photo on the site comes straight from the Shopify product at full resolution
   (srcset up to 3840px / 4K, so each screen downloads the sharpest size it can show),
   placeholders are filled with the real product photo, and floor mats show their in-car footwell shot. */
(() => {
  // Floor mats: the photo to show by default (the footwell shot). Mats not listed use their first photo.
  const FOOT = {
    'luffy-zoro-floor-mats': 'Luffy_Final.jpg',
    'dragon-x-koi-floor-mats': '1FINAL.jpg',
    'sharigan-manga-panel-floor-mat': 'Sharingan_Final.jpg',
    'the-dragons-palace-floor-mats': 'RyuxTemple_FInal.jpg',
    'the-oni-masks-floor-mats': 'DSC_0722.jpg',
    'kami-no-ichimatsu-series-red-checkered-floor-mat-set': 'onimaskcharm_0002_A6705245.jpg',
    'oni-mask-x-snake-japanese-tattoo-style-floor-mats': 'DSC_0353_15097e0a-95d5-4912-9785-e282b968fc90.jpg',
    'kitsune-x-geisha-floor-mats': 'DSC_0361_10915656-62c4-479d-9372-be3c64623a3f.jpg',
    'the-dragon-tattoo-unreleased-floor-mat': 'DSC_0316.jpg',
    'the-clash-of-gods-floor-mats': 'DSC_0038_2f4a334e-18fc-43aa-a7fa-48e027764140.jpg',
    'zoro-wanted-poster-floor-mats': 'DSC_0620.jpg',
    'kokushibo-vs-the-strongest-floor-mats': 'DSC_0301.jpg',
    'ps2-samurai-x-ryu-reboot-floor-mats': 'DSC_0764.jpg',
    'floor-mat-protection-pvc-floor-mats': 'DSC_0267.jpg',
    'interior-display-level-floor-mat-genji': 'Untitled-9_0002_Layer15.jpg',
    'one-piece-wanted-poster-floor-mats': 'DSC_0574.jpg',
    'kami-no-ichimatsu-grey-checkered-floor-mat-set': 'DSC_0586.jpg',
    'charizard-floor-mats': 'DSC_0266.jpg',
    'dragon-ball-z-x-ukiyo-e-style-floor-mats': 'dbzfm.jpg',
    'geisha-x-lion-japanese-tattoo-style-floor-mats': 'DSC_0265_f321fb5b-dc5b-4931-8896-bae29ce52f25.jpg',
    'rock-lee-manga-panel-floor-mat': 'DSC_0897.jpg',
    'fujins-war-at-mount-fuji-floor-mat': 'DSC_0923.jpg',
    'gengar-irezumi-collection': 'DSC_0116-2.jpg'
  };
  // products with no in-car / product photo worth swapping in: keep the curated picture already on the page
  const KEEP = new Set([]);
  const MAT_TILE = 'the-oni-masks-floor-mats'; // "Floor mats" tile in the Interior row shows the Oni Masks mats in the footwell
  // Category tiles: label words -> the collection whose top product photo to use
  const TILE = [
    [/floor ?mat/i, null], [/seat ?belt/i, 'seatbelt-cushions'], [/headrest/i, 'jdm-headrests'],
    [/shift ?knob|shifter/i, 'q:shift knob'], [/omamori|charm/i, 'p:oni-mask-omamori-charm-fearless'], [/fresh/i, 'jdm-air-fresheners'],
    [/jet ?tag/i, 'jet-tags'], [/lanyard|key/i, 'jdm-lanyards'], [/decal|sticker/i, 'car-decals'],
    [/apparel|tee|hoodie/i, 'jdm-apparel'], [/interior (pack|build)|theme pack/i, 'interior-builds']
  ];
  const W = [480, 720, 960, 1440, 1920, 2560, 3840];

  const bn = u => String(u || '').split('/').pop().split('?')[0];
  const abs = u => (u.startsWith('//') ? 'https:' + u : u);
  const at = (u, w) => { u = abs(u).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); return u + (u.includes('?') ? '&' : '?') + 'width=' + w; };

  const cache = {};
  const once = (k, f) => cache[k] || (cache[k] = f().catch(() => null));
  const prod = h => once('p:' + h, () => fetch('/products/' + encodeURIComponent(h) + '.js').then(r => (r.ok ? r.json() : null)));
  const search = q => once('q:' + q, () => fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=1')
    .then(r => (r.ok ? r.json() : null)).then(j => { const p = j && j.resources.results.products[0]; return p ? p.handle : null; }));
  const CAT = [[/floor|rear mat/i, 'floor mats', /floor-mat|mats?$/], [/headrest/i, 'headrest', /headrest/], [/seat ?belt/i, 'seatbelt cushion', /seatbelt/],
    [/omamori|charm/i, 'omamori charm', /omamori|charm/], [/fresh/i, 'air freshener', /freshener/]];
  // builder options whose name the store search matches to the wrong product
  const NAMES = {
    'floor mats|Gengar × Irezumi': 'gengar-irezumi-collection',
    'floor mats|Oni Mask x Snake': 'oni-mask-x-snake-japanese-tattoo-style-floor-mats',
    'floor mats|Kitsune x Geisha': 'kitsune-x-geisha-floor-mats',
    'floor mats|The Dragon Tattoo': 'the-dragon-tattoo-unreleased-floor-mat',
    'air freshener|Gengar VMAX': 'gengar-vma',
    'air freshener|Cardcaptor Sakura, The Nothing': 'cardcaptor-sakura-the-nothing-1'
  };
  const searchIn = (q, re) => once('s:' + q, () => fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
    .then(r => (r.ok ? r.json() : null)).then(j => { const p = j && j.resources.results.products.find(x => re.test(x.handle)); return p ? p.handle : null; }));
  const topOf = c => once('c:' + c, () => fetch('/collections/' + c + '/products.json?limit=1').then(r => (r.ok ? r.json() : null))
    .then(j => (j && j.products[0] ? j.products[0].handle : null)));

  // the photo a product should show: footwell shot for floor mats, otherwise its first photo
  function pick(p) {
    const imgs = (p.images || []).map(abs);
    if (!imgs.length) return null;
    const want = FOOT[p.handle];
    if (want) { const m = imgs.find(u => bn(u) === want); if (m) return m; }
    return imgs[0];
  }

  function apply(img, url) {
    if (!url) return;
    const w = Math.round(img.getBoundingClientRect().width);
    img.sizes = w > 20 ? w + 'px' : '(min-width: 900px) 33vw, 60vw'; // hidden right now (menu, other page): size it generously
    img.srcset = W.map(x => at(url, x) + ' ' + x + 'w').join(', ');
    img.src = at(url, 1920);
    img.__set = img.src;
    img.classList.add('ph-fixed');
    img.dataset.hd = bn(url);
  }

  // which product (handle) a picture belongs to
  async function target(img) {
    const card = img.closest('[data-h]');
    if (card) return card.dataset.h;
    const a = img.closest('a[href]');
    const href = a ? a.getAttribute('href') : '';
    const pm = href.match(/^\/products\/([^/?#]+)/);
    if (pm) return pm[1];
    const label = (img.alt || (img.closest('a,button,.bi,.pc') || {}).textContent || '').trim();
    if (/^\/collections\//.test(href) || img.closest('.itile')) {
      for (const [re, src] of TILE) {
        if (!re.test(label)) continue;
        if (!src) return MAT_TILE;
        return src.startsWith('q:') ? search(src.slice(2)) : src.startsWith('p:') ? src.slice(2) : topOf(src);
      }
      const cm = href.match(/^\/collections\/([^/?#]+)/);
      if (cm && /jdm-floor-mats/.test(cm[1])) return MAT_TILE;
      return cm ? topOf(cm[1]) : null;
    }
    const opt = img.closest('.bz-opt,.bi,.pc');
    if (opt) {
      const b = opt.querySelector('b,h3'); const n = b && b.textContent.replace(/\s+rear$/i, '').trim(); if (!n) return null;
      // bundle builder steps: search within the step's product type so "Sharingan" in the mats step finds the mat, not the headrest
      const step = opt.closest('section,[class*="step"]'); const st = step && step.querySelector('h3,h4');
      const cat = st && CAT.find(c => c[0].test(st.textContent));
      const fixed = NAMES[(cat ? cat[1] : '') + '|' + n]; if (fixed) return fixed;
      return cat ? searchIn(n + ' ' + cat[1], cat[2]) : search(n);
    }
    return null;
  }

  async function upgrade(img) {
    if (img.__hd) return; img.__hd = 1; img.__fx = 1; // __fx: tells the older placeholder fixer to leave it alone
    try {
      const src = img.getAttribute('src') || '';
      const h = await target(img);
      if (h && KEEP.has(h) && !/^data:/.test(src)) return;
      if (h) { const p = await prod(h); const u = p && pick(p); if (u) { if (!img.getAttribute('alt') && p.title) img.alt = p.title.split('|')[0].trim(); return apply(img, u); } }
      // already a Shopify product photo (e.g. product page gallery): just serve it at full resolution
      if (/\/cdn\/shop\/(files|products)\//.test(src) || /cdn\.shopify\.com\/s\/files\//.test(src)) apply(img, src);
    } catch (_) {}
  }

  const eligible = i => {
    if (i.__hd || i.closest('.mys,.gift,.mr-sc,.swh')) return false;
    const s = i.getAttribute('src') || '';
    // hand-made theme pictures (feature banners like the Ryu x Koi bundle pack, menus, drawer) stay as designed;
    // only product cards, bundle builder options and the Interior row tiles get swapped for product photos
    if (/\/assets\//.test(s) && !i.closest('[data-h],.bz-opt,.itile')) return false;
    return /^data:image\/svg/.test(s) || /\/assets\/im-/.test(s) || /\/cdn\/shop\/(files|products)\//.test(s) || /cdn\.shopify\.com\/s\/files\//.test(s);
  };
  const relevant = i => i.closest('[data-h],a[href^="/products/"],a[href^="/collections/"],.itile,.bz-opt,.bi,.pc,#pdimg,#pdsimg') ||
    i.id === 'pdimg' || i.id === 'pdsimg' || /\/cdn\/shop\/(files|products)\//.test(i.getAttribute('src') || '');

  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { io.unobserve(e.target); upgrade(e.target); } }), { rootMargin: '900px' })
    : null;
  const scan = () => document.querySelectorAll('img').forEach(i => {
    if (i.__hdo || !eligible(i) || !relevant(i)) return;
    i.__hdo = 1; i.__fx = 1;
    io ? io.observe(i) : upgrade(i);
  });
  // when the app swaps a photo's src itself (e.g. product page gallery), re-upgrade it
  new MutationObserver(ms => {
    ms.forEach(m => { if (m.type === 'attributes' && m.target.tagName === 'IMG' && m.target.__set && m.target.src !== m.target.__set) { m.target.__hd = 0; m.target.__hdo = 0; m.target.__set = null; } });
    clearTimeout(scan.t); scan.t = setTimeout(scan, 200);
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  scan(); setTimeout(scan, 1500);
})();
